'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

/**
 * Redirects to '/' unless the logged-in user's type is super_admin.
 * Mirrors the inline guard pattern in super-admin/lookups/page.tsx and
 * super-admin/rate-master/page.tsx — extracted here so the 8 new Rate
 * Master v2 screens don't each repeat the same useEffect.
 */
export function useSuperAdminGuard(): void {
  const router = useRouter();

  useEffect(() => {
    const userType = localStorage.getItem('user_type');
    if (userType !== 'super_admin' && userType !== 'SUPER_ADMIN') {
      router.push('/');
    }
  }, [router]);
}
